/**
 * Keep the Header Wishlist count synchronized with the shared t4s_wis storage contract.
 * The Wishlist mini apps update localStorage in the current tab, so the Storage API
 * hooks below complement the native cross-tab storage event.
 */
(function () {
  const WISHLIST_KEY = 't4s_wis';
  const COUNT_SELECTOR = '[data-doyo-wishlist-count]';
  const CHANGE_EVENT = 'doyo:wishlist-changed';

  function getWishlistCount() {
    try {
      const storedValue = window.localStorage.getItem(WISHLIST_KEY);
      if (!storedValue) return 0;

      return storedValue
        .split(',')
        .map((item) => item.trim())
        .filter(Boolean).length;
    } catch (error) {
      return 0;
    }
  }

  function renderWishlistCount() {
    const count = getWishlistCount();

    document.querySelectorAll(COUNT_SELECTOR).forEach((element) => {
      element.textContent = count > 99 ? '99+' : String(count);
      element.hidden = count === 0;
      element.setAttribute('aria-hidden', String(count === 0));
    });
  }

  function scheduleRender() {
    window.requestAnimationFrame(renderWishlistCount);
  }

  window.addEventListener('storage', (event) => {
    if (event.key === WISHLIST_KEY || event.key === null) scheduleRender();
  });
  window.addEventListener(CHANGE_EVENT, scheduleRender);

  if (!Storage.prototype.__doyoWishlistBadgePatched) {
    const originalSetItem = Storage.prototype.setItem;
    const originalRemoveItem = Storage.prototype.removeItem;
    const originalClear = Storage.prototype.clear;

    Storage.prototype.setItem = function (key, value) {
      originalSetItem.call(this, key, value);
      if (key === WISHLIST_KEY && this === window.localStorage) window.dispatchEvent(new Event(CHANGE_EVENT));
    };

    Storage.prototype.removeItem = function (key) {
      originalRemoveItem.call(this, key);
      if (key === WISHLIST_KEY && this === window.localStorage) window.dispatchEvent(new Event(CHANGE_EVENT));
    };

    Storage.prototype.clear = function () {
      originalClear.call(this);
      if (this === window.localStorage) window.dispatchEvent(new Event(CHANGE_EVENT));
    };

    Object.defineProperty(Storage.prototype, '__doyoWishlistBadgePatched', { value: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', renderWishlistCount, { once: true });
  } else {
    renderWishlistCount();
  }
})();
